import React from 'react'

import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Avatar, Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const iconSize = 24
const useStyles = makeStyles((theme) => ({
  stepIcon: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    height: iconSize,
    width: iconSize,
    marginRight: theme.spacing(1),
  },
  inactiveStepIcon: {
    backgroundColor: theme.palette.grey[600],
    color: theme.palette.text.white,
    height: iconSize,
    width: iconSize,
    marginRight: theme.spacing(1),
  },
  stepNumber: {
    fontSize: theme.typography.pxToRem(12),
  },
}))

const StepHeader = ({ number, text, isActive, isComplete }) => {
  const styles = useStyles()
  const iconStyle = isActive ? styles.stepIcon : styles.inactiveStepIcon
  const numberText = number.toString()

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      mt={4}
      mb={4}
    >
      <Avatar className={iconStyle}>
        {isComplete ? (
          <FontAwesomeIcon
            icon={faCheck}
            size="xs"
          />
        ) : (
          <Typography className={styles.stepNumber}>{numberText}</Typography>
        )}
      </Avatar>
      <Typography
        variant="subtitle2"
        component="h2"
        color={isActive ? 'textPrimary' : 'textSecondary'}
      >
        {text}
      </Typography>
    </Box>
  )
}

StepHeader.propTypes = {
  number: PropTypes.number,
  text: PropTypes.string,
  isActive: PropTypes.bool,
  isComplete: PropTypes.bool,
}

export default StepHeader
